<template>
    <div>
        <div v-show="parentShow">
            <Form :model="formItem" :label-width="100" inline>
                <Form-item label="门店编号">
                    <Input type="text" v-model="formItem.stid"></Input>
                </Form-item>
                <Form-item label="门店编码">
                    <Input type="text" v-model="formItem.scode"></Input>
                </Form-item>
                <Form-item label="门店名称">
                    <Input type="text" v-model="formItem.sname"></Input>
                </Form-item>
                <Form-item label="类型">
                    <Input type="text" v-model="formItem.storetype"></Input>
                </Form-item>
                <Form-item label="大区">
                    <Input type="text" v-model="formItem.area"></Input>
                </Form-item>
                <Form-item label="三级门店类型">
                    <Input type="text" v-model="formItem.thirdtype"></Input>
                </Form-item>
                <Form-item>
                    <Button type="primary" @click="init">查询</Button>
                </Form-item>
                <Form-item>
                    <Button type="primary" @click="exportFn">导出查询结果</Button>
                    <Button type="primary" @click="pushFn">玛氏门店导入</Button>
                    <Button type="primary" @click="deleteAllFn">批量删除</Button>
                </Form-item>
            </Form>
            <Table border :columns="columns" :data="data"></Table>
            <div class="clearfix page">
                <Page :total="pageTotal" class="fr" @on-change="pageChange" @on-page-size-change="pageSize"
                      :current="formItem.start+1" placement="top" show-elevator show-sizer></Page>
            </div>
            <el-dialog title="删除" :visible.sync="deleteShow">
                <p>确定要删除门店？</p>
                <div slot="footer" class="dialog-footer">
                    <Button @click="deleteShow=false">取 消</Button>
                    <Button type="primary" @click="deleteFn">确 定</Button>
                </div>
            </el-dialog>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                formItem: {
                    stid: '',
                    scode: '',
                    sname: '',
                    storetype: '',
                    area: '',
                    thirdtype: '',
                    start: 0,
                    length: 10,
                },
                stid: '',
                columns: [
                    {
                        title: '门店编号',
                        key: 'stid'
                    }, {
                        title: '门店编码',
                        key: 'scode'
                    }, {
                        title: '门店名称',
                        key: 'sname'
                    }, {
                        title: '大区',
                        key: 'area'
                    }, {
                        title: '省份',
                        key: 'province'
                    }, {
                        title: '城市群',
                        key: 'citys'
                    }, {
                        title: '地级市',
                        key: 'pcity'
                    }, {
                        title: '县级市',
                        key: 'ccity'
                    }, {
                        title: '一级门店类型',
                        key: 'firsttype'
                    }, {
                        title: '二级门店类型',
                        key: 'secondtype'
                    }, {
                        title: '三级门店类型',
                        key: 'thirdtype'
                    }, {
                        title: '门店地址',
                        key: 'sloction'
                    }, {
                        title: '类型',
                        key: 'stype'
                    }, {
                        title: '创建时间',
                        key: 'cdate'
                    }, {
                        title: '操作',
                        width: 190,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.stid = params.row.stid;
                                            this.deleteShow = true;
                                        }
                                    }
                                }, '删除'),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.$router.push({
                                                path: '/store/seeStore',
                                                query: {stid: params.row.stid}
                                            });
                                        }
                                    }
                                }, '查看详情'),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.$router.push({
                                                path: '/store/modifyStore',
                                                query: {stid: params.row.stid}
                                            });
                                        }
                                    }
                                }, '修改'),
                            ]);
                        }
                    }
                ],
                data: [],
                pageTotal: 0,
                deleteShow: false,
            }
        },
        watch: {
            $route(to, from) {
                if (to.path == '/store') ;
                this.$store.dispatch('parentShowFn');
            }
        },
        computed: {
            parentShow() {
                return this.$store.state.parentShow;
            }
        },
        created() {
            this.$store.dispatch('parentShowFn');
            this.getData();
        },
        methods: {
            pushFn() {
                this.$router.push({path: '/store/pushStore'});
            },
            exportFn() {
                var _this = this;
                this.$Modal.confirm({
                    content: '确认要导出报表吗？',
                    onOk() {
                        var jsonData = JSON.parse(JSON.stringify(_this.formItem));
                        delete jsonData['start'];
                        delete jsonData['length'];
                        var jsonArr = [];
                        for (var name in jsonData) {
                            jsonArr.push(name + '=' + jsonData[name]);
                        }
                        var jsonStr = jsonArr.join('&');
                        window.open('/checker_web/web/store/exportListDBStore?' + jsonStr);
                    },
                });
            },
            deleteFn() {
                this.deleteShow = false;
                var _this = this;
                this.$http.get('/web/store/deleteStoreByStid', {
                    params: {
                        stid: _this.stid
                    }
                }).then(function (res) {
                    if (res.success) {
                        _this.$Notice.success({
                            title: '删除门店',
                            desc: res.message
                        });
                        _this.getData();
                    } else {
                        _this.$Notice.error({
                            title: '删除门店',
                            desc: res.message
                        });
                    }
                    _this.$Message.success('加载成功');
                }).catch(function (res) {
                    _this.$Message.error('加载失败');
                })
            },
            deleteAllFn() {
                var _this = this;
                this.$Modal.confirm({
                    content: '确认要批量删除吗？',
                    onOk() {
                        var jsonData = JSON.parse(JSON.stringify(_this.formItem));
                        delete jsonData['start'];
                        delete jsonData['length'];
                        _this.$http.get('/web/store/deleteStoreBatch', {
                            params: jsonData
                        }).then(function (res) {
                            if (res.success) {
                                _this.$Notice.success({
                                    title: '删除门店',
                                    desc: res.message
                                });
                                _this.init();
                            } else {
                                _this.$Notice.error({
                                    title: '删除门店',
                                    desc: res.message
                                });
                            }
                            _this.$Message.success('加载成功');
                        }).catch(function (res) {
                            _this.$Message.error('加载失败');
                        })
                    },
                });
            },
            getData() {
                var _this = this;
                this.$http.get('/web/store/listStore', {
                    params: _this.formItem
                }).then(function (res) {
                    _this.data = res.data;
                    _this.pageTotal = res.recordsTotal;
                    _this.$Message.success('加载成功');
                }).catch(function (res) {
                    _this.$Message.error('加载失败');
                })
            },
            pageChange(res) {
                this.formItem.start = res - 1;
                this.getData();
            },
            pageSize(res) {
                this.formItem.length = res;
                this.getData();
            },
            init() {
                this.formItem.start = 0;
                this.getData();
            },
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/store/infoStore.vue